import type { SVGProps } from 'react'
const SvgSyPhone = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M21.3 22.6c-2.5 0-4.9-.5-7.3-1.6s-4.6-2.6-6.6-4.6-3.5-4.2-4.6-6.6S1.2 5 1.2 2.5s.1-.7.4-.9.5-.4.9-.4h4.8c.3 0 .5 0 .7.3s.3.4.4.7l.8 4.1v.8l-.3.6L6 10.6c.4.7.9 1.4 1.4 2.1s1.1 1.3 1.8 2c.6.6 1.3 1.2 1.9 1.7s1.4 1 2.1 1.4L16 15c.2-.2.4-.3.7-.4s.6-.1.8 0l4.1.8c.3 0 .5.2.7.4s.3.4.3.7v4.8c0 .4-.1.7-.4.9s-.5.4-.9.4" />
	</svg>
)
export default SvgSyPhone
